import React from "react";
import { MapPin, Ticket, ShoppingBag, ArrowRight } from "lucide-react";

const ONLINE_STORE_URL = "https://corecolchon.com/";
const STORE_MAPS_URL = "https://www.google.com/maps/place/CORECOLCHON+Navalcarnero/@40.2897109,-3.9895563,15.03z/data=!3m1!5s0xd419479dd659685:0x723b9826fd326775!4m8!3m7!1s0xd4195c903a5626f:0x853a2d96771aefe8!8m2!3d40.2906374!4d-3.9916294!9m1!1b1!16s%2Fg%2F11pcsk89l6";

function OptionCard({ testid, icon: Icon, kicker, title, text, cta, href, external, featured, children }) {
  const base = featured
    ? "bg-[#8B1538] text-white border-[#8B1538] shadow-[0_20px_60px_rgba(139,21,56,0.35)] md:-translate-y-3"
    : "bg-white text-[#2E2638] border-[#E3DDE8] hover:border-[#8B1538]/40";
  const sub = featured ? "text-white/85" : "text-[#5C5366]";
  const btn = featured ? "bg-white text-[#8B1538] hover:bg-[#F9F0F3]" : "bg-[#2E2638] text-white hover:bg-[#8B1538]";
  return (
    <div data-testid={testid} className={`relative w-full border p-7 sm:p-8 flex flex-col transition-colors ${base}`}>
      {featured && (
        <span className="absolute -top-3 left-7 bg-[#E2B6C5] text-[#2E2638] text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1">Recomendado</span>
      )}
      <div className={`w-12 h-12 flex items-center justify-center mb-5 ${featured ? "bg-white/15" : "bg-[#F9F0F3] text-[#8B1538]"}`}>
        <Icon size={22}/>
      </div>
      <div className={`text-[10px] uppercase tracking-[0.25em] font-bold mb-2 ${featured ? "text-[#E2B6C5]" : "text-[#8B1538]"}`}>{kicker}</div>
      <h3 className="font-display text-2xl font-bold leading-tight">{title}</h3>
      <p className={`mt-3 text-sm sm:text-base ${sub}`}>{text}</p>
      {children && <div className={`mt-4 text-sm ${sub}`}>{children}</div>}
      <div className="mt-auto pt-7">
        <a
          href={href}
          {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          data-testid={`${testid}-cta`}
          className={`w-full px-6 py-4 font-bold uppercase tracking-wider text-xs sm:text-sm inline-flex items-center justify-center gap-2 transition-colors ${btn}`}
        >
          {cta} <ArrowRight size={16}/>
        </a>
      </div>
    </div>
  );
}

export default function EligeOpcion({ id, testid, tiendaText }) {
  return (
    <section id={id} data-testid={testid} className="py-16 sm:py-20 bg-[#F9F8FA] border-y border-[#E3DDE8]">
      <div className="max-w-7xl mx-auto px-5 sm:px-10">
        <div className="max-w-2xl mb-10 sm:mb-14">
          <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-[#8B1538] mb-3">Tú eliges</div>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#2E2638] leading-tight">Elige cómo quieres conseguir tu Core Colchón.</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6 md:gap-5 lg:gap-8 items-stretch">
          <div className="order-2 md:order-1 flex">
            <OptionCard testid={`${testid}-tienda`} icon={MapPin} kicker="Pruébalo en tienda" title="Ven a probarlo a Navalcarnero" text={tiendaText} cta="Cómo llegar" href={STORE_MAPS_URL} external>
              <div className="font-semibold text-[#2E2638]">Muebles Muñoz · C/ Dehesa de Mari Martín, 27</div>
              <div>Autovía N-V · 28600 Navalcarnero</div>
              <div className="mt-1">L–S · 10:00–14:00 · 17:00–20:30</div>
            </OptionCard>
          </div>
          <div className="order-1 md:order-2 flex">
            <OptionCard testid={`${testid}-cheque`} icon={Ticket} kicker="Descuento exclusivo" title="Solicita tu cheque de 100€" text="Déjanos tus datos y recibe el cheque en tu email para canjearlo en nuestra tienda de Navalcarnero." cta="Quiero mi cheque" href="#hero-form" featured>
              <div>Sin compromiso · Válido en todas las medidas</div>
            </OptionCard>
          </div>
          <div className="order-3 flex">
            <OptionCard testid={`${testid}-online`} icon={ShoppingBag} kicker="Compra online" title="Cómpralo en nuestra tienda online" text="Elige tu medida y la firmeza de cada lado desde casa." cta="Comprar online" href={ONLINE_STORE_URL} external>
              <div className="font-semibold text-[#2E2638]">Garantía de 100 noches de prueba</div>
            </OptionCard>
          </div>
        </div>
      </div>
    </section>
  );
}
